<template>
  <!--
      作者：Lz
      时间：2019-10-25
      描述：来自:会员-用户列表-会员充值 --资金操作
  -->
  <el-dialog :title="item.name" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false" width="60%">
    <el-form size="small" :model="item">
      <el-form-item label="当前资金额" :label-width="formLabelWidth">
        <el-input v-model="item.money" autocomplete="off" disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="充值方式" :label-width="formLabelWidth">
        <el-radio-group v-model="rechargeForm.mode">
          <el-radio label="inc">增加</el-radio>
          <el-radio label="dec">减少</el-radio>
          <el-radio label="final">最终金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="变更金额" :label-width="formLabelWidth">
        <el-input v-model="rechargeForm.money" autocomplete="off" placeholder="请输入变更金额"></el-input>
      </el-form-item>
      <el-form-item label="管理员备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="rechargeForm.remark" placeholder="请输入管理员备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from "@/api/user";
export default {
  data() {
    return {
      loading: false,
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      rechargeForm: {
        funds_pool_id: '',
        mode: '',
        money: '',
        remark: '',
      },
    };
  },
  props: {
    open_add: Boolean,
    item: Object,
  },
  created() {
    this.dialogVisible = this.open_add;
    this.rechargeForm.funds_pool_id = this.item.funds_pool_id
  },
  methods: {
    /*充值*/
    addUser(e) {
      let self = this;
      if (!self.rechargeForm.mode) {
        return  self.$message.warning('请选择充值方式')
      }
      self.loading = true;
      UserApi.fundsPoolRecharge(self.rechargeForm).then(data => {
        self.loading = false;
        if (data.code == 1) {
          self.$message({message: '恭喜你，修改成功', type: 'success'});
          self.dialogFormVisible(true);
        } else {
          self.loading = false;
          self.$message.error('错了哦，这是一条错误消息');
        }
      }).catch(error => {
        self.loading = false;
      });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/fundpool/dialog/Recharge.vue